import { Card, Form, Col } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { getOrderStatsData, OrderStatsData } from 'api/dashboard/_request';
import EcomProductSpentChart from 'components/charts/EcomProductSpentChart';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

type RangeType = 'today' | 'week' | 'month' | 'year';

const PRESET_RANGES: { label: string; value: RangeType }[] = [
  { label: 'Today', value: 'today' },
  { label: 'This Week', value: 'week' },
  { label: 'This Month', value: 'month' },
  { label: 'This Year', value: 'year' }
];

const EcomProductSpentsByOrder = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const id = user?._id;
  const [range, setRange] = useState<RangeType>('year');
  const [orderStatsData, setOrderStatsData] = useState<OrderStatsData>({
    totalSpent: 0,
    totalProducts: 0,
    count: 0
  });
  useEffect(() => {
    const fetchData = async () => {
      const params = { range, id };
      try {
        const data = await getOrderStatsData(params);
        setOrderStatsData(data);
      } catch (error) {
        console.error('Failed to fetch product data:', error);
      }
    };
    fetchData();
  }, [range]);

  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column">
        <div className="d-flex justify-content-between">
          <div>
            <h5 className="mb-2">Product Sales</h5>
            <h6 className="text-body-tertiary">Last {range}</h6>
          </div>
          <Col xs={8} sm={6}>
            <Form.Select
              size="sm"
              value={range}
              onChange={e => setRange(e.target.value as RangeType)}
            >
              {PRESET_RANGES.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </Form.Select>
          </Col>
        </div>
        <div className="d-flex justify-content-center pt-3 flex-1">
          <EcomProductSpentChart data={orderStatsData} range={range} />
        </div>
        <div className="mt-3">
          <div className="d-flex justify-content-between">
            <h6>Total Sold:</h6>
            <h6 className="text-success">SAR {orderStatsData?.totalSpent}</h6>
          </div>
          <div className="d-flex justify-content-between">
            <h6>Total Products:</h6>
            <h6 className="text-primary">
              {orderStatsData.totalProducts} items
            </h6>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default EcomProductSpentsByOrder;
